export default __webpack_public_path__ + "static/media/overtime.9981e3cc.svg";